import type { FulfillmentOrder, FulfillmentOrderLine } from "../types";

/** 横向展示工作区内已生成的供应商协议。 */
export function FulfillmentOrderAgreementCard({
  orders,
  lines = [],
  onSelect,
  formatAmount,
}: {
  orders: FulfillmentOrder[];
  lines?: FulfillmentOrderLine[];
  onSelect: (orderId: string) => void;
  formatAmount?: (amount: string) => string;
}) {
  return (
    <section className="fulfillment-order-agreement-strip" aria-label="供应商协议工作区">
      {orders.length ? (
        <div className="fulfillment-order-agreement-scroll">
          {orders.map((order) => {
            const lineCount = lines.filter(
              (line) => line.status === "active" && line.fulfillmentOrderId === order.id,
            ).length;
            return (
              <button
                key={order.id}
                type="button"
                className="fulfillment-order-agreement-trigger fulfillment-order-agreement-card"
                aria-label={`查看 ${order.orderNo}`}
                onClick={() => onSelect(order.id)}
              >
                <span className="fulfillment-order-agreement-card-meta">
                  <small title={order.orderNo}>{order.orderNo}</small>
                  <span className={`fulfillment-order-agreement-status${order.status === "effective" ? " is-effective" : ""}`}>
                    {order.status === "effective" ? "已生效" : "待盖章"}
                  </span>
                </span>
                <strong title={order.settlementSupplierName}>{order.settlementSupplierName}</strong>
                <em className="money-value">{formatAmount ? formatAmount(order.currentAmount) : `¥ ${order.currentAmount}`}</em>
                <span>{lineCount} 条确认行</span>
              </button>
            );
          })}
        </div>
      ) : (
        <div className="fulfillment-order-agreement-empty" role="status">
          <strong>尚未生成供应商协议</strong>
          <span>勾选确认行并选择结算主体后，可直接生成确认协议。</span>
        </div>
      )}
    </section>
  );
}
